module.exports = __webpack_public_path__ + "img/bus-station-red.a9a7d052.svg";